<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="!showForm">
      <b-col lg="8">
        <b-card >
          <div slot="header">Password Reset Log 
            <div class="card-header-actions">
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
              <button class="btn btn-primary mr-1" @click="exportxls()">
                <i class="fa fa-file-excel-o"></i>
                Export
            </button>
            </div>
          </div>
          <b-row >
            <b-col md="8">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2 mr-2">User Name</span></b-input-group-prepend>
                      <b-form-input readonly v-model="tblData.username" placeholder="Select User !" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuUserShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
            </b-col>
            <b-col md="4">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
            </b-col>

          </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @row-clicked="rowClicked"
            show-empty
          >
          <template v-slot:cell(nomor)="data">
            {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
          </template>
          <template v-slot:cell(resettime)="data">
            {{ data.item.resettime | moment("ddd DD-MMM-YYYY hh:mm:ss") }}
          </template>
            <template v-slot:cell(empty)="scope">
                  <h4>{{ scope.emptyText }}</h4>
            </template>
            <template v-slot:cell(emptyfiltered)="scope">
                <h4>{{ scope.emptyFilteredText }}</h4>
            </template>
          </b-table>
      <b-row >
        <b-col cols="5">
            <b-row>
              <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
              <b-button size="sm" class="ml-3" @click="showForm=true"  >Add User Role</b-button>                          
            </b-row>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols="4" label="Limit per page"  style="margin-top:0 !important;">
              <b-form-select :options="[10, 15, 20, 25, 30, 40, 50]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="3">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

        </b-card>

      </b-col>
    </b-row>



    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
        <lku-user @click="onSelectUser"></lku-user>
    </b-modal>        
  </div>
</template>


<script>
import toastr from "mini-toastr";
import lkuUser from "../lookup/lkuUser";
import crud from "../../apis/crud";

toastr.init();

export default {
  components: {lkuUser},
  data() {
    return {
      showForm: false,
      showDelConfirm: false,
      lkuUserShow:false,
      lkuCompanyShow:false,
      frmdata:{user_id: '', username: '', role_name:'' },
      userRoles:[],userRolesFilt:[],
      tblData: {
        tablename:'user-reset-log',
        page: 1,
        total: 0,
        limit:10,
        sortBy: 'username',
        sortDesc: false, customQuery:''
      },
      tblFields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "username",
            label: "User Name",
            sortable: true
          },
          {
            key: "full_name",
            label: "Full Name",
            sortable: true
          },
          {
            key: "resettime",
            label: "Reset Time",
            sortable: true
          },
          {
            key: "resetby",
            label: "Reset By",
            sortable: true
          },
      ],

      list:[],
    };
  },
  computed: {    
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {
    onSelectUser(_selected) {
        this.tblData.username = _selected.username;
        this.tblData.user_id = _selected.user_id;
        this.frmdata.username = _selected.username;
        this.frmdata.user_id = _selected.user_id;
        this.lkuUserShow=false;
        // this.refresh();
    },
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let  customQuery ='';
      if (this.tblData.user_id) {
        customQuery += customQuery ? '&' : '';
          customQuery +=`user_id=${this.tblData.user_id}`;
      } 
      this.tblData.customQuery= customQuery ;
      
      const list = await crud.list(this.tblData);    
      // console.log(list) ;
      this.list=list; 
      return this.list;
    },
    exportxls: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let  customQuery ='';
      if (this.tblData.user_id) {
        customQuery += customQuery ? '&' : '';
          customQuery +=`user_id=${this.tblData.user_id}`;
      } 
      this.tblData.customQuery= customQuery ;
      
      const response = await crud.exportxls(this.tblData);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `password_reset_log.xlsx`);
        document.body.appendChild(link);
        link.click();
    },
    search() {
      this.tblData.page=1;
      if (this.$refs.table) this.$refs.table.refresh();
    },
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter() {
        this.filter.username= '';
        this.filter.user_id='';
        this.refresh();
    },

    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    close(){
      router.push("home");
    },    
  }
};
</script>
